import { render, staticRenderFns } from "./DeleteProfile.vue?vue&type=template&id=490bc914"
import script from "./DeleteProfile.vue?vue&type=script&lang=js"
export * from "./DeleteProfile.vue?vue&type=script&lang=js"
import style0 from "./DeleteProfile.vue?vue&type=style&index=0&id=490bc914&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports